module.exports = __webpack_public_path__ + "img/bgi.46f2923a.jpg";